import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    completeMessage:
      'Thank you for filling in your company information. We will now ask you for a few supporting documents to complete your profile.',
    continueCta: 'All good! Continue',
    title: 'You’re doing great!',
  },
  fr: {
    completeMessage:
      'Merci pour ces informations sur votre société.\nNous allons vous demander quelques documents justificatifs pour compléter votre profil.',
    continueCta: 'Continuer',
    title: 'Parfait\u00A0!',
  },
} as const);
